export default __webpack_public_path__ + "images/787f873cb97486016b10423fd682c2b7-spotify_logo.svg";